import {configUtil} from '../config';

class UiHelper {
    constructor() {

    }

    registerDriverBtn(optConfig) {
        let config = {
            'downloadDriverBtn': optConfig
        };
        configUtil.setConfig(config);
    }
}

export default UiHelper;